import { takeLatest, put, call } from 'redux-saga/effects';
import { apiRequest } from '../../apiRequest';
import { URLs } from '../../urls';

import {
    GetStudentDetailsActionsTypes,
    GetStudentAnalyticsActionsTypes,
    UpdateStudentDetailsActionsTypes,
    IGetStudentDetailsResult,
    IGetStudentAnalyticsResult,
    IUpdateStudentDetailsResult,
    GetStudentDetailsRequestSuccess,
    GetStudentDetailsRequestError,
    GetStudentAnalyticsRequestSuccess,
    GetStudentAnalyticsRequestError,
    UpdateStudentDetailsRequestSuccess,
    UpdateStudentDetailsRequestError,
} from './types';

// GET student details
function* sendGetStudentDetailsRequest(action: any) {
    try {
        const response: IGetStudentDetailsResult = yield call(apiRequest, {
            endpoint: `${URLs.GET_STUDENT_DETAILS_ENDPOINT}/${action.id}`,
            method: 'GET',
        });

        if (response.success === true) {
            const putData: GetStudentDetailsRequestSuccess = {
                type: GetStudentDetailsActionsTypes.GET_STUDENT_DETAILS_SUCCESS,
                data: response.data,
                loading: false,
            };
            yield put<GetStudentDetailsRequestSuccess>(putData);
        }

        if (response.success === false) {
            const putData: GetStudentDetailsRequestError = {
                type: GetStudentDetailsActionsTypes.GET_STUDENT_DETAILS_ERROR,
                error: response.error.toString(),
                loading: false
            };
            yield put<GetStudentDetailsRequestError>(putData);
        }

    } catch (e: any) {
        const putData: GetStudentDetailsRequestError = {
            type: GetStudentDetailsActionsTypes.GET_STUDENT_DETAILS_ERROR,
            error: e.message || 'Unknown error',
            loading: false
        };
        yield put<GetStudentDetailsRequestError>(putData);
    }
}

// GET student analytics (grades, tests, subjects stats)
function* sendGetStudentAnalyticsRequest(action: any) {
    try {
        const response: IGetStudentAnalyticsResult = yield call(apiRequest, {
            endpoint: `${URLs.GET_STUDENT_ANALYTICS_ENDPOINT}/${action.studentId}/analytics`,
            method: 'GET',
        });

        if (response.success === true) {
            const putData: GetStudentAnalyticsRequestSuccess = {
                type: GetStudentAnalyticsActionsTypes.GET_STUDENT_ANALYTICS_SUCCESS,
                data: response.data,
                loading: false,
            };
            yield put<GetStudentAnalyticsRequestSuccess>(putData);
        }

        if (response.success === false) {
            const putData: GetStudentAnalyticsRequestError = {
                type: GetStudentAnalyticsActionsTypes.GET_STUDENT_ANALYTICS_ERROR,
                error: response.error.toString(),
                loading: false
            };
            yield put<GetStudentAnalyticsRequestError>(putData);
        }

    } catch (e: any) {
        const putData: GetStudentAnalyticsRequestError = {
            type: GetStudentAnalyticsActionsTypes.GET_STUDENT_ANALYTICS_ERROR,
            error: e.message || 'Unknown error',
            loading: false
        };
        yield put<GetStudentAnalyticsRequestError>(putData);
    }
}

// PUT update student details
function* sendUpdateStudentDetailsRequest(action: any) {
    try {
        const response: IUpdateStudentDetailsResult = yield call(apiRequest, {
            endpoint: `${URLs.UPDATE_STUDENT_DETAILS_ENDPOINT}/${action.model.id}`,
            method: 'PUT',
            body: action.model
        });

        if (response.success === true) {
            const putData: UpdateStudentDetailsRequestSuccess = {
                type: UpdateStudentDetailsActionsTypes.PUT_UPDATE_STUDENT_DETAILS_SUCCESS,
                data: response.data,
                loading: false,
            };
            yield put<UpdateStudentDetailsRequestSuccess>(putData);
        }

        if (response.success === false) {
            const putData: UpdateStudentDetailsRequestError = {
                type: UpdateStudentDetailsActionsTypes.PUT_UPDATE_STUDENT_DETAILS_ERROR,
                error: response.error.toString(),
                loading: false
            };
            yield put<UpdateStudentDetailsRequestError>(putData);
        }

    } catch (e: any) {
        const putData: UpdateStudentDetailsRequestError = {
            type: UpdateStudentDetailsActionsTypes.PUT_UPDATE_STUDENT_DETAILS_ERROR,
            error: e.message || 'Unknown error',
            loading: false
        };
        yield put<UpdateStudentDetailsRequestError>(putData);
    }
}

export function* handler() {
    yield takeLatest(GetStudentDetailsActionsTypes.GET_STUDENT_DETAILS, sendGetStudentDetailsRequest);
    yield takeLatest(GetStudentAnalyticsActionsTypes.GET_STUDENT_ANALYTICS, sendGetStudentAnalyticsRequest);
    yield takeLatest(UpdateStudentDetailsActionsTypes.PUT_UPDATE_STUDENT_DETAILS, sendUpdateStudentDetailsRequest);
}
